
// Helper to attach subtasks to their respective tasks for forecast hours calculation
const attachSubtasksToTasks = (sectionData, subtasks) => {
    // Create a map of subtasks grouped by taskId
    const subtaskMap = new Map();
    subtasks.forEach(subtask => {
        if (!subtaskMap.has(subtask.taskId)) {
            subtaskMap.set(subtask.taskId, []);
        }
        subtaskMap.get(subtask.taskId).push(subtask);
    });

    // Recursive function to attach subtasks to tasks in nested structure
    const attachSubtasksRecursively = (stages) => {
        return stages.map(stage => {
            if (stage.stages && Array.isArray(stage.stages)) {
                // Handle nested stages recursively
                return {
                    ...stage,
                    stages: attachSubtasksRecursively(stage.stages)
                };
            } else if (stage.stages === null && stage.tasks) {
                // Handle tasks at this level
                return {
                    ...stage,
                    tasks: (stage.tasks || []).map(task => ({
                        ...task,
                        subtasks: subtaskMap.get(task.id) || []
                    }))
                };
            } else {
                // Handle tasks directly on stage (fallback)
                return {
                    ...stage,
                    tasks: (stage.tasks || []).map(task => ({
                        ...task,
                        subtasks: subtaskMap.get(task.id) || []
                    }))
                };
            }
        });
    };

    return attachSubtasksRecursively(sectionData);
};

export default attachSubtasksToTasks;